/* OB Cycling · additions behaviour. Runs once (window.__obp). Sections: quiz, bundles, pay later, feature, weather,
   shop the look, countdown, audience tabs, sticky bar. Shared "add these items" flow: [data-obp-group] containing
   [data-obp-item] rows (variant in data-v or a <select data-obp-size>, optional checkbox data-obp-on), a total
   [data-obp-total] and a button [data-obp-add] (data-code = discount code applied after adding). */
(function () {
  if (window.__obp) return;
  window.__obp = true;
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  if (root.slice(-1) !== '/') root += '/';

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var cur = window.obcyCur || 'AED';
    if (cur === 'AED') return '<bdi dir="ltr"><span class="po-aed" aria-hidden="true"></span><span class="obcy-vh">AED </span>' + s + '</bdi>';
    return '<bdi dir="ltr">' + cur + ' ' + s + '</bdi>';
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- shared add flow ---------- */
  function items(g) {
    return Array.prototype.filter.call(g.querySelectorAll('[data-obp-item]'), function (r) {
      if (r.closest('[hidden]')) return false;
      var on = r.querySelector('[data-obp-on]');
      return !on || on.checked;
    });
  }
  function vid(r) { var s = r.querySelector('[data-obp-size]'); return s ? s.value : r.getAttribute('data-v'); }
  function price(r) {
    var s = r.querySelector('[data-obp-size]');
    if (s && s.selectedOptions[0]) return +s.selectedOptions[0].getAttribute('data-p') || 0;
    return +r.getAttribute('data-p') || 0;
  }
  function total(g) {
    var list = items(g), sum = 0;
    list.forEach(function (r) { sum += price(r); });
    var save = +(g.getAttribute('data-save') || 0);
    var out = Math.max(sum - save, 0);
    g.querySelectorAll('[data-obp-total]').forEach(function (el) { el.innerHTML = money(out); });
    g.querySelectorAll('[data-obp-was]').forEach(function (el) { el.innerHTML = save > 0 ? money(sum) : ''; });
    g.querySelectorAll('[data-obp-count]').forEach(function (el) { el.textContent = list.length; });
    var n = +(g.getAttribute('data-pl-n') || 0);
    g.querySelectorAll('[data-obp-inst]').forEach(function (el) { el.innerHTML = n ? money(Math.ceil(out / n / 100) * 100) : ''; });
    g.querySelectorAll('[data-obp-add]').forEach(function (b) { b.disabled = list.length === 0; });
    return out;
  }
  function addGroup(g, btn) {
    var list = items(g);
    if (!list.length) return;
    var err = g.querySelector('[data-obp-err]');
    if (err) err.hidden = true;
    btn.disabled = true;
    var props = {};
    var name = g.getAttribute('data-obp-name');
    if (name) props._kit = name;
    var body = { items: list.map(function (r) { var o = { id: +vid(r), quantity: 1 }; if (name) o.properties = props; return o; }) };
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var code = btn.getAttribute('data-code') || g.getAttribute('data-code');
        location.href = code ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart') : root + 'cart';
      })
      .catch(function () { btn.disabled = false; if (err) err.hidden = false; });
  }
  document.addEventListener('change', function (e) {
    var g = e.target.closest && e.target.closest('[data-obp-group]');
    if (!g) return;
    if (e.target.matches('[data-obp-on]')) e.target.closest('[data-obp-item]').classList.toggle('is-off', !e.target.checked);
    total(g);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-obp-add]');
    if (!b) return;
    var g = b.closest('[data-obp-group]');
    if (g) { e.preventDefault(); addGroup(g, b); }
  });
  function initGroups(scope) { (scope || document).querySelectorAll('[data-obp-group]').forEach(total); }

  /* ---------- quiz ---------- */
  function initQuiz(q) {
    if (q.__obp) return; q.__obp = true;
    var ans = {};
    var go = q.querySelector('[data-obp-quiz-go]');
    q.addEventListener('click', function (e) {
      var o = e.target.closest('[data-q]');
      if (o) {
        var k = o.getAttribute('data-q');
        q.querySelectorAll('[data-q="' + k + '"]').forEach(function (b) { b.setAttribute('aria-pressed', b === o ? 'true' : 'false'); });
        ans[k] = o.getAttribute('data-a');
        go.disabled = !(ans.where && ans.level && ans.budget);
        return;
      }
      if (e.target.closest('[data-obp-quiz-go]')) {
        var best = null, bestScore = -1;
        q.querySelectorAll('[data-obp-result]').forEach(function (p) {
          var s = 0, ok = true;
          ['where', 'level', 'budget'].forEach(function (k) {
            var v = p.getAttribute('data-' + k);
            if (v === 'any') return;
            if (v === ans[k]) s += 2; else ok = false;
          });
          if (ok && s > bestScore) { best = p; bestScore = s; }
        });
        var all = q.querySelectorAll('[data-obp-result]');
        if (!best) best = all[all.length - 1];
        q.querySelectorAll('[data-obp-res-empty]').forEach(function (el) { el.hidden = true; });
        all.forEach(function (p) { p.hidden = p !== best; });
        if (best) {
          total(best);
          if (window.innerWidth < 990) best.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  /* ---------- weather (Open-Meteo, no key) ---------- */
  function initWeather(w) {
    if (w.__obp) return; w.__obp = true;
    var cities = JSON.parse(w.getAttribute('data-cities') || '[]');
    var hour = +(w.getAttribute('data-hour') || 6);
    var cold = +(w.getAttribute('data-cold') || 16), warm = +(w.getAttribute('data-warm') || 22);
    var key = 'obp-wx-city';
    var cur = +(store(key) || 0);
    if (!cities[cur]) cur = 0;
    var cache = {};
    function band(t) { return t < cold ? 'cold' : (t > warm ? 'warm' : 'mild'); }
    function show(i) {
      cur = i; store(key, String(i));
      w.querySelectorAll('[data-city]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-city') === i ? 'true' : 'false'); });
      var c = cities[i];
      w.querySelectorAll('[data-obp-wx-city]').forEach(function (el) { el.textContent = c.name; });
      if (cache[i]) return paint(cache[i]);
      w.classList.add('is-loading');
      var u = 'https://api.open-meteo.com/v1/forecast?latitude=' + c.lat + '&longitude=' + c.lon + '&hourly=temperature_2m,apparent_temperature,wind_speed_10m&timezone=Asia%2FDubai&forecast_days=2';
      fetch(u).then(function (r) { return r.json(); }).then(function (d) {
        var h = d.hourly, at = -1, at9 = -1;
        var tm = new Date(Date.now() + 864e5).toLocaleDateString('en-CA', { timeZone: 'Asia/Dubai' });
        var hh = ('0' + hour).slice(-2) + ':00', h9 = ('0' + Math.min(hour + 3, 23)).slice(-2) + ':00';
        for (var k = 0; k < h.time.length; k++) {
          if (h.time[k] === tm + 'T' + hh) at = k;
          if (h.time[k] === tm + 'T' + h9) at9 = k;
        }
        if (at < 0) throw new Error('hour');
        cache[i] = { t: h.temperature_2m[at], f: h.apparent_temperature[at], wd: h.wind_speed_10m[at], t9: at9 > -1 ? h.temperature_2m[at9] : h.temperature_2m[at] };
        if (cur === i) paint(cache[i]);
      }).catch(function () { cache[i] = null; paint(null); });
    }
    function paint(x) {
      w.classList.remove('is-loading');
      var set = function (sel, v) { w.querySelectorAll(sel).forEach(function (el) { el.textContent = v; }); };
      if (!x) {
        set('[data-obp-wx-t]', '–'); set('[data-obp-wx-f]', '–'); set('[data-obp-wx-w]', '–');
        set('[data-obp-wx-note]', w.getAttribute('data-l-fail') || '');
        pick('mild'); return;
      }
      set('[data-obp-wx-t]', Math.round(x.t) + '°');
      set('[data-obp-wx-f]', Math.round(x.f) + '°');
      set('[data-obp-wx-w]', Math.round(x.wd) + ' km/h');
      set('[data-obp-wx-note]', (x.t9 - x.t >= 3 ? w.getAttribute('data-l-warmup') : w.getAttribute('data-l-steady')) || '');
      pick(band(x.t));
    }
    function pick(b) {
      var panels = w.querySelectorAll('[data-obp-band]'), found = false;
      panels.forEach(function (p) { var on = p.getAttribute('data-obp-band') === b; p.hidden = !on; if (on) { found = true; total(p); } });
      if (!found && panels[0]) { panels[0].hidden = false; total(panels[0]); }
    }
    w.addEventListener('click', function (e) { var b = e.target.closest('[data-city]'); if (b) show(+b.getAttribute('data-city')); });
    if (cities.length) show(cur);
  }

  /* ---------- shop the look ---------- */
  function initLook(l) {
    if (l.__obp) return; l.__obp = true;
    l.addEventListener('click', function (e) {
      var d = e.target.closest('[data-obp-dot]');
      if (!d) return;
      var n = d.getAttribute('data-obp-dot');
      l.querySelectorAll('[data-obp-dot]').forEach(function (x) { x.setAttribute('aria-pressed', x === d ? 'true' : 'false'); });
      l.querySelectorAll('[data-obp-item]').forEach(function (r) {
        var on = r.getAttribute('data-n') === n;
        r.classList.toggle('is-hl', on);
        if (on && window.innerWidth < 990) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(c) {
    if (c.__obp) return; c.__obp = true;
    var end = Date.parse(c.getAttribute('data-end'));
    var sec = c.closest('.obcy');
    if (isNaN(end)) return;
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { if (sec && !(window.Shopify && Shopify.designMode)) sec.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      c.querySelector('[data-d]').textContent = d;
      c.querySelector('[data-h]').textContent = ('0' + h).slice(-2);
      c.querySelector('[data-m]').textContent = ('0' + m).slice(-2);
      setTimeout(tick, 30000);
    }
    tick();
  }

  /* ---------- tabs ---------- */
  function initTabs(t) {
    if (t.__obp) return; t.__obp = true;
    t.addEventListener('click', function (e) {
      var b = e.target.closest('[data-obp-tab]');
      if (!b) return;
      var i = b.getAttribute('data-obp-tab');
      t.querySelectorAll('[data-obp-tab]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      t.querySelectorAll('[data-obp-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-obp-panel') !== i;
        if (!p.hidden) p.querySelectorAll('[data-obcy-r]').forEach(function (r) { r.classList.add('is-in'); });
      });
    });
  }

  /* ---------- pay later line on store cards ---------- */
  var plCfg = null;
  function payLater(scope) {
    if (!plCfg) return;
    (scope || document).querySelectorAll('.po-pr').forEach(function (pr) {
      if (pr.__obp) return;
      var amt = pr.querySelector('.po-pr__amt');
      if (!amt) return;
      pr.__obp = true;
      var v = parseFloat(amt.textContent.replace(/[^0-9.]/g, ''));
      var row = document.createElement('div');
      row.className = 'obp-pl';
      if (!v || v < plCfg.min) { row.style.visibility = 'hidden'; row.innerHTML = '<span class="obp-pl__b">&nbsp;</span>'; }
      else {
        var each = Math.ceil(v / plCfg.n);
        row.innerHTML = '<span class="obp-pl__b">' + plCfg.p + '</span><span>' + plCfg.n + ' × ' + money(each * 100) + (plCfg.t ? ', ' + plCfg.t : '') + '</span>';
      }
      pr.insertAdjacentElement('afterend', row);
    });
  }

  /* ---------- sticky bar ---------- */
  function initSticky(s) {
    if (s.__obp) return; s.__obp = true;
    var after = +(s.getAttribute('data-after') || 500);
    var ft = document.querySelector('footer, .footer, #shopify-section-footer');
    function on() {
      var y = window.scrollY, nearEnd = ft && ft.getBoundingClientRect().top < window.innerHeight;
      s.classList.toggle('is-on', y > after && !nearEnd);
    }
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  function init(scope) {
    scope = scope || document;
    var pl = document.querySelector('[data-obp-pl]');
    if (pl) plCfg = { p: pl.getAttribute('data-p'), n: +pl.getAttribute('data-n') || 4, min: +pl.getAttribute('data-min') || 0, t: pl.getAttribute('data-t') };
    scope.querySelectorAll('[data-obp-quiz]').forEach(initQuiz);
    scope.querySelectorAll('[data-obp-wx]').forEach(initWeather);
    scope.querySelectorAll('[data-obp-look]').forEach(initLook);
    scope.querySelectorAll('[data-obp-cd]').forEach(initCountdown);
    scope.querySelectorAll('[data-obp-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-obp-sticky]').forEach(initSticky);
    initGroups(scope);
    payLater(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(function () { payLater(document); }, 200); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
